import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {NotificationService} from './core/notification/notification.service';
import {NgxPermissionsService} from 'ngx-permissions';
import {SettingsService} from './core/settings/settings.service';
import {GlobalComponentView} from './core/globals/global-component-view';
import {Subscription} from 'rxjs';
import {HelperFunctions} from './core/table/configuration/helper-functions';
import { SsoUserService } from './auth/sso-user.service';

/**
 * The entry component for the application
 */

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Supplier Qualification';
  loadedProfile: any = null;
  subscriptions: Array<Subscription> = [];
  constructor(private readonly deviceDetectorService: DeviceDetectorService,
              private readonly notificationsService: NotificationService,
              private readonly permissionsService: NgxPermissionsService,
              private readonly settingsService: SettingsService,
              private readonly userService: SsoUserService,
              private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    var isMobile = this.deviceDetectorService.isMobile();
    GlobalComponentView.cdr = this.cdr;
    this.settingsService.getProfile();
    this.subscriptions.push(this.settingsService.profileData.subscribe(() => {
      if (HelperFunctions.currentProfile) {
        GlobalComponentView.setRenderAllowed();
        this.permissionsService.flushPermissions();
        this.permissionsService.loadPermissions(HelperFunctions.currentProfile.Claims);
        this.loadedProfile = HelperFunctions.currentProfile;
        this.onLogin(isMobile);
        this.subscriptions.push(this.permissionsService.permissions$.subscribe(() => this.cdr.detectChanges()));
      }
    }));
    const isFirstTime = localStorage.getItem('firstTime');
    if (isMobile && isFirstTime !== 'true') {
     this.notificationsService.showBetterOnDesktopNotification().subscribe(() => localStorage.setItem('firstTime', 'true'));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onLogin(isMobile:boolean = false){
    var news = "";
    const isPostLogin = localStorage.getItem('showedNewsOnLogin');
    if(!isPostLogin){
      this.subscriptions.push(this.settingsService.getNewsOnLogin().subscribe({
        next: (data: Blob) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const htmlContent = event.target?.result as string;
            news = htmlContent;
            this.notificationsService.showNewsNotification(isMobile, news).subscribe(() => localStorage.setItem('showedNewsOnLogin', 'true'));
          };
          reader.onerror = (error) => {
            console.error('Error reading HTML content:', error);
          };
          reader.readAsText(data);
        },
        error: (error) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorDetail = JSON.parse(reader.result as string);
              console.error('Failed Loading News:', errorDetail);
            } catch (e) {
              console.error('Error parsing loading News:', e);
            } finally {
              localStorage.setItem('showedNewsOnLogin', 'true');
            }
          };
          reader.onerror = () => {
            console.error('Error reading loading News:', reader.error);
            localStorage.setItem('showedNewsOnLogin', 'true');
          };
          reader.readAsText(error.error);
        }
      }));
    }
  }
}
